module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pageContent",
    staticStyle: {
      "position": "absolute"
    }
  }, [(false) ? _c('div', {
    staticStyle: {
      "z-index": "1111",
      "border": "1px solid #ccc",
      "max-width": "480px",
      "width": "100%",
      "overflow": "hidden",
      "color": "#333",
      "position": "fixed",
      "background-color": "white"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left",
      "line-height": "100%",
      "padding": "0.5rem 0.2rem 0.3rem 0.2rem"
    },
    on: {
      "click": function($event) {
        return _vm.showToggle()
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": "0.22rem",
      "margin": "0 auto"
    },
    attrs: {
      "src": require("../../../static/home/index/icon_close.png")
    }
  })]), _vm._v(" "), _c('img', {
    staticStyle: {
      "float": "left",
      "width": "1.24rem"
    },
    attrs: {
      "src": require("../../../static/home/index/logoapp.png")
    },
    on: {
      "click": function($event) {
        return _vm.GoDown()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "margin-top": "0.2rem",
      "line-height": "1.6",
      "font-size": "0.28rem"
    },
    on: {
      "click": function($event) {
        return _vm.GoDown()
      }
    }
  }, [_c('div', [_vm._v("下载APP得￥100代金券礼包")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "0.22rem",
      "color": "#999"
    }
  }, [_vm._v("绑定手机和邮箱再得￥100")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "background-color": "#27ba69",
      "width": "1.5rem",
      "text-align": "center",
      "height": "1.24rem",
      "color": "white",
      "padding-top": "0.4rem",
      "font-size": "0.3rem"
    },
    on: {
      "click": function($event) {
        return _vm.GoDown()
      }
    }
  }, [_vm._v("立即下载")])]) : _vm._e(), _vm._v(" "), (false) ? _c('div', {
    staticStyle: {
      "height": "1.24rem"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "slider",
    staticStyle: {
      "max-height": "4.3rem"
    }
  }, [_c('swiper', {
    attrs: {
      "options": _vm.swiperOption11
    }
  }, [_vm._l((_vm.banners), function(item, index) {
    return _c('swiper-slide', {
      key: index
    }, [_c('img', {
      attrs: {
        "src": item.url
      },
      on: {
        "click": function($event) {
          return _vm.bannerGoto(item.detailUrl)
        }
      }
    })])
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "search"
  }, [_c('mu-paper', {
    staticClass: "demo-paper",
    attrs: {
      "zDepth": 1
    }
  }, [_c('div', {
    staticClass: "search-panel"
  }, [_c('mu-tabs', {
    staticClass: "tabDiv",
    attrs: {
      "value": _vm.activeTab
    },
    on: {
      "change": _vm.handleTabChange
    }
  }, [_c('mu-tab', {
    attrs: {
      "value": "tabFirst",
      "title": "全日房"
    }
  }), _vm._v(" "), _c('mu-tab', {
    attrs: {
      "value": "tabSecond",
      "title": "休闲房"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab === 'tabFirst'),
      expression: "activeTab === 'tabFirst'"
    }],
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "id": "Index_FirstPage"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "position": "absolute",
      "z-index": "999999"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toWxUrll.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('mu-text-field', {
    attrs: {
      "hintText": "城市",
      "id": "FirstCity",
      "type": "text",
      "icon": "location_city",
      "iconClass": "colorCCC",
      "underlineShow": ""
    },
    on: {
      "focus": _vm.selectCity
    },
    model: {
      value: (this.g_currentCityName),
      callback: function($$v) {
        _vm.$set(this, "g_currentCityName", $$v)
      },
      expression: "this.g_currentCityName"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "padding-right": "0.4rem"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/search/nearbyHotels"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "0.35rem",
      "margin-top": "0.3rem"
    },
    attrs: {
      "src": require("../../../static/home/index/near.png")
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "padding-top": "0.3rem"
    }
  }, [_vm._v("附近酒店")])])], 1), _vm._v(" "), _c('mu-divider', {
    staticClass: "dividerClass"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "overflow": "hidden"
    }
  }, [_c('div', {
    staticClass: "BoxLeft",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('mu-date-picker', {
    attrs: {
      "format": _vm.dateFormt,
      "maxDate": _vm.checkinMaxDate,
      "minDate": _vm.checkinMinDate,
      "hintText": "入住日期",
      "icon": "date_range",
      "iconClass": "colorCCC"
    },
    on: {
      "change": _vm.checkinDateChange
    },
    model: {
      value: (_vm.g_searchParam.startDate),
      callback: function($$v) {
        _vm.$set(_vm.g_searchParam, "startDate", $$v)
      },
      expression: "g_searchParam.startDate"
    }
  }), _vm._v(" "), (_vm.BuyZero == true) ? _c('div', {
    staticStyle: {
      "position": "absolute",
      "margin": "-0.7rem 0 0 1rem",
      "z-index": "999999",
      "width": "2.5rem",
      "height": "0.7rem"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "DateShow"
  }, [_c('div', {
    staticStyle: {
      "font-size": "0.28rem"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.checkInDateFormat) + "\n                  "), (_vm.BuyZero == true) ? _c('span', {
    staticStyle: {
      "font-size": "0.2rem",
      "color": "#FF8F3B"
    }
  }, [_vm._v("凌晨入住")]) : _c('span', {
    staticStyle: {
      "font-size": "0.2rem",
      "color": "#FF8F3B"
    }
  }, [_vm._v("入住")])])])], 1), _vm._v(" "), (!_vm.ShowZero) ? _c('div', {
    staticStyle: {
      "width": "0.9rem",
      "height": "0.1rem",
      "float": "left"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "BoxRight",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('mu-date-picker', {
    attrs: {
      "format": _vm.dateFormt,
      "hintText": "离店日期",
      "maxDate": _vm.checkoutMaxDate,
      "minDate": _vm.checkoutMinDate
    },
    on: {
      "change": _vm.checkoutDateChange
    },
    model: {
      value: (_vm.g_searchParam.endDate),
      callback: function($$v) {
        _vm.$set(_vm.g_searchParam, "endDate", $$v)
      },
      expression: "g_searchParam.endDate"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "DateShow",
    staticStyle: {
      "left": "0"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "0.28rem"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.checkOutDateFormat) + "\n                  "), (_vm.BuyZero == true) ? _c('span', {
    staticStyle: {
      "font-size": "0.2rem"
    }
  }, [_vm._v("中午离店")]) : _c('span', {
    staticStyle: {
      "font-size": "0.2rem"
    }
  }, [_vm._v("离店")])])])], 1), _vm._v(" "), (_vm.ShowZero) ? _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticStyle: {
      "position": "absolute",
      "line-height": "55px",
      "right": "0",
      "z-index": "999999",
      "width": "2rem",
      "font-size": "0.25rem"
    }
  }, [(_vm.BuyZero == false) ? _c('span', {
    staticClass: "TEXT_primaryColor",
    staticStyle: {
      "z-index": "999999"
    }
  }, [_vm._v("凌晨房")]) : _c('span', {
    staticClass: "TEXT_primaryColor",
    staticStyle: {
      "color": "transparent",
      "z-index": "999999"
    }
  }, [_vm._v("占格子")]), _vm._v(" "), _c('mu-switch', {
    staticStyle: {
      "margin": "0 0 0  0.1rem",
      "bottom": "-0.02rem"
    },
    on: {
      "change": _vm.changeZero
    }
  })], 1)]) : _vm._e()]), _vm._v(" "), _c('mu-divider', {
    staticClass: "dividerClass"
  }), _vm._v(" "), _c('mu-text-field', {
    attrs: {
      "inputClass": "selectKey",
      "fullWidth": true,
      "type": "text",
      "icon": "search",
      "iconClass": "colorCCC"
    },
    on: {
      "focus": _vm.selectKey
    },
    model: {
      value: (this.g_searchKeyWord),
      callback: function($$v) {
        _vm.$set(this, "g_searchKeyWord", $$v)
      },
      expression: "this.g_searchKeyWord"
    }
  }), _vm._v(" "), _c('mu-divider', {
    staticClass: "dividerClass"
  }), _vm._v(" "), _c('mu-flexbox-item', {
    staticClass: "flex-search"
  }, [_c('mu-raised-button', {
    staticStyle: {
      "font-size": "0.32rem"
    },
    style: ({
      width: '90%',
      height: '50px'
    }),
    attrs: {
      "label": "开始预订",
      "primary": ""
    },
    on: {
      "click": _vm.searchHotel
    }
  })], 1), _vm._v(" "), _c('mu-divider')], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab === 'tabSecond'),
      expression: "activeTab === 'tabSecond'"
    }],
    attrs: {
      "id": "Index_SecondPage"
    }
  }, [_c('mu-text-field', {
    attrs: {
      "hintText": "城市",
      "id": "SecondCity",
      "type": "text",
      "icon": "location_city",
      "iconClass": "colorCCC",
      "underlineShow": ""
    },
    on: {
      "focus": _vm.selectCity
    },
    model: {
      value: (this.g_currentCityName),
      callback: function($$v) {
        _vm.$set(this, "g_currentCityName", $$v)
      },
      expression: "this.g_currentCityName"
    }
  }), _vm._v(" "), _c('mu-divider', {
    staticClass: "dividerClass"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('mu-date-picker', {
    staticStyle: {
      "float": "left",
      "width": "3rem"
    },
    attrs: {
      "id": "SecondCity",
      "format": "YYYY-MM-DD",
      "hintText": "入住日期",
      "icon": "date_range",
      "iconClass": "colorCCC",
      "maxDate": _vm.checkinMaxDate,
      "minDate": _vm.checkinMinDate
    },
    on: {
      "change": _vm.setRelaxDate
    },
    model: {
      value: (_vm.g_searchParam.arriveDate),
      callback: function($$v) {
        _vm.$set(_vm.g_searchParam, "arriveDate", $$v)
      },
      expression: "g_searchParam.arriveDate"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "formatDate",
    staticStyle: {
      "font-size": "0.28rem"
    }
  }, [_vm._v(_vm._s(_vm.arriveDateFormat))])], 1), _vm._v(" "), _c('mu-dropDown-menu', {
    staticStyle: {
      "float": "right",
      "width": "2.5rem",
      "margin-top": "-0.07rem",
      "font-size": "0.3rem"
    },
    attrs: {
      "value": _vm.relaxHour,
      "icon": "search",
      "iconClass": "colorCCC",
      "id": "Timehomeindex"
    },
    on: {
      "change": _vm.setRelaxHour
    }
  }, [_c('mu-menu-item', {
    attrs: {
      "value": "11",
      "title": "11:00"
    }
  }), _vm._v(" "), _c('mu-menu-item', {
    attrs: {
      "value": "12",
      "title": "12:00"
    }
  }), _vm._v(" "), _c('mu-menu-item', {
    attrs: {
      "value": "13",
      "title": "13:00"
    }
  }), _vm._v(" "), _c('mu-menu-item', {
    attrs: {
      "value": "14",
      "title": "14:00"
    }
  }), _vm._v(" "), _c('mu-menu-item', {
    attrs: {
      "value": "15",
      "title": "15:00"
    }
  }), _vm._v(" "), _c('mu-menu-item', {
    attrs: {
      "value": "16",
      "title": "16:00"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('mu-divider', {
    staticClass: "dividerClass"
  }), _vm._v(" "), _c('mu-text-field', {
    attrs: {
      "inputClass": "selectKey",
      "fullWidth": true,
      "type": "text",
      "icon": "search",
      "iconClass": "colorCCC"
    },
    on: {
      "focus": _vm.selectKey
    },
    model: {
      value: (this.g_searchKeyWord),
      callback: function($$v) {
        _vm.$set(this, "g_searchKeyWord", $$v)
      },
      expression: "this.g_searchKeyWord"
    }
  }), _vm._v(" "), _c('mu-divider', {
    staticClass: "dividerClass"
  }), _vm._v(" "), _c('mu-flexbox-item', {
    staticClass: "flex-search"
  }, [_c('mu-raised-button', {
    staticStyle: {
      "font-size": "0.32rem"
    },
    style: ({
      width: '90%',
      height: '50px'
    }),
    attrs: {
      "label": "开始预订",
      "primary": ""
    },
    on: {
      "click": function($event) {
        return _vm.goListToRelax()
      }
    }
  })], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "0.2rem"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "subMenu",
    staticStyle: {
      "color": "#666666"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "EntranceBox"
  }, [_c('span', {
    on: {
      "click": function($event) {
        return _vm.GoRedBag()
      }
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', [_vm._v("限时红包")])])]), _vm._v(" "), _c('div', {
    staticClass: "EntranceBox"
  }, [_c('span', {
    on: {
      "click": function($event) {
        return _vm.GoActivityList()
      }
    }
  }, [_vm._m(2), _vm._v(" "), _c('div', [_vm._v("活动")])])]), _vm._v(" "), _c('div', {
    staticClass: "EntranceBox"
  }, [_c('span', {
    on: {
      "click": function($event) {
        return _vm.GoNewsCenter()
      }
    }
  }, [_vm._m(3), _vm._v(" "), _c('div', [_vm._v("新闻")])])]), _vm._v(" "), _vm._m(4)])], 1), _vm._v(" "), _c('div', {
    staticClass: "brands",
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_c('h3', [_vm._v("品牌")]), _vm._v(" "), _c('div', {
    staticClass: "slider"
  }, [_c('swiper', {
    attrs: {
      "options": _vm.swiperOption22
    }
  }, [_vm._l((_vm.brands), function(item, index) {
    return _c('swiper-slide', {
      key: index
    }, [_c('img', {
      attrs: {
        "src": item.url
      },
      on: {
        "click": function($event) {
          return _vm.BrandGoto(item.id)
        }
      }
    })])
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  })], 2)], 1)]), _vm._v(" "), _vm._m(5)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "EntranceBox"
  }, [_c('a', {
    attrs: {
      "href": "https://www.168.com/mobile/index/index.html "
    }
  }, [_c('div', [_c('img', {
    attrs: {
      "src": require("../../../static/home/index/168.png")
    }
  })]), _vm._v(" "), _c('div', [_vm._v("168商城")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": require("../../../static/home/index/RedBag.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": require("../../../static/home/index/activity.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": require("../../../static/home/index/news.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "EntranceBox"
  }, [_c('a', {
    attrs: {
      "href": "https://i.998.com/applink.htm"
    }
  }, [_c('div', [_c('img', {
    attrs: {
      "src": require("../../../static/home/index/app.png")
    }
  })]), _vm._v(" "), _c('div', [_vm._v("下载APP")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "enters",
    staticStyle: {
      "margin-top": "40px",
      "border-bottom": "none",
      "text-align": "center",
      "font-size": "0.2rem",
      "color": "#27ba69"
    }
  }, [_c('a', {
    attrs: {
      "href": "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010702001346"
    }
  }, [_vm._v("沪公网安备 31010702001346号")]), _vm._v(" "), _c('br'), _vm._v("格林豪泰酒店（中国）有限公司版权所有\n    "), _c('br'), _c('a', {
    attrs: {
      "href": "http://beian.miit.gov.cn"
    }
  }, [_vm._v("沪ICP备14035076号")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-01d369c5!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/home/index.vue
// module id = 1406
// module chunks = 18